module.exports = __webpack_public_path__ + "img/biglz.514ab136.png";